export class ResponseTotalCartAmountInfoModel {

    totalOneTimeFee: number;
    totalMonthlyRecurringFee: number;
    totalPrice: number;
    currencyCode: string;
}
